import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import Whatsapp from './Whatsapp'
import priorityProjects from '../data/priorityProjects'
import ProjectDetailModal from './ProjectDetailModal'

const CROWDED_DONATION_EMBED_URL =
  'https://collect.crowded.me/collection/6f3c4a9c-a4f5-4964-8eeb-8ef7e8035395/embedded-v2'

export default function Donation() {
  const [activeProjectId, setActiveProjectId] = useState(null)
  const activeProject = priorityProjects.find((p) => p.id === activeProjectId) || null

  return (
    <>
      <div className="main-wrapper page page-donation">
        <Navbar />
        <div className="content-wrapper">
          <div className="about-us" data-aos="fade-up">
            <div className="about-us-title text-center">
              <div className="container">
                <h1 className="heading-bold text-uppercase">Give Back to LITU</h1>
                <p className="page-hero-subtitle">
                  Our alma mater gave us the foundation for everything we have built. Now it is our turn.
                </p>
              </div>
            </div>
          </div>

          <section className="litaana-give-page" data-aos="fade-up">
            <div className="container">
              <div className="give-page-intro">
                <h2>LITAA North America Chapter</h2>
                <p className="give-page-ein">Registered 501(c)(3) nonprofit | EIN: 39-2341136</p>
                <Link to="/contactus" className="bnt bnt-theme give-page-cta">
                  Contact Us to Give
                </Link>
              </div>

              <div className="give-page-card" data-aos="fade-up">
                <h3>Support Our Alma Mater</h3>
                <p>
                  Laxminarayan Innovation Technological University — the institution that shaped us — is at a pivotal moment. After more than 80 years as one of India&apos;s most respected chemical engineering institutions, LITU has recently achieved autonomous university status and is actively modernizing its campus, programs, and facilities to serve the next generation of students.
                </p>
                <p>
                  The LITAA North America Chapter, as a registered 501(c)(3) nonprofit, channels the generosity of our North American alumni community toward projects that make the most immediate and lasting difference. Contributions are tax-deductible for US donors to the extent permitted by law.
                </p>
              </div>

              <div className="give-page-card" data-aos="fade-up" data-aos-delay="100">
                <h3>Priority Projects</h3>
                <p>Your contribution can support:</p>
                <ul className="give-page-list">
                  {priorityProjects.map((project) => (
                    <li key={project.id}>
                      <button
                        type="button"
                        className="give-page-list__item--clickable"
                        onClick={() => setActiveProjectId(project.id)}
                      >
                        {project.summary}
                        <span className="give-page-list__hint" aria-hidden="true">Read more →</span>
                      </button>
                    </li>
                  ))}
                </ul>
                <p className="give-page-list-note">
                  Click any project above for full details.
                </p>
              </div>

              <div className="give-page-card give-page-card--donate" data-aos="fade-up" data-aos-delay="200">
                <h3>Donate Online</h3>
                <p>
                  Make a secure contribution below. For questions or other giving options, use Contact Us to Give above or below.
                </p>
                <div className="give-page-donate-embed">
                  <iframe
                    src={CROWDED_DONATION_EMBED_URL}
                    title="Donate to LITAA North America Chapter"
                    width="410"
                    height="900"
                    loading="lazy"
                    allowFullScreen
                  />
                </div>
                <ul className="give-page-list give-page-list--checks">
                  <li>Donations are tax-deductible for US taxpayers (EIN: 39-2341136)</li>
                  <li>Contributions may be made in your name or in honor of someone you wish to recognize</li>
                  <li>INR amounts are approximate and subject to exchange rate variation</li>
                </ul>
              </div>

              <div className="give-page-footer-cta text-center" data-aos="zoom-in">
                <Link to="/contactus" className="bnt bnt-theme">
                  Contact Us to Give
                </Link>
              </div>
            </div>
          </section>

          <ProjectDetailModal
            project={activeProject}
            isOpen={Boolean(activeProject)}
            onClose={() => setActiveProjectId(null)}
          />

          <Whatsapp />
        </div>
        <Footer />
      </div>
    </>
  )
}
